module.exports = __webpack_public_path__ + "4a8cda636545b78f26671d6e1e3097bc.png";